import React from 'react'
import { SeeOurProductsButton } from '../../components/SeeOurProductsButton'
import { EmptyContent } from '@ztechapps/webui.util'

export const EmptyCart = () => {
  return (
    <div className="p-5">
      <EmptyContent
        icon="box"
        message="Your cart still empty!"
        subMessage="Please add new item by browsing our products list."
        action={<SeeOurProductsButton />}
      />
    </div>
  )
}
